import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';

import { useChatOverlayContext } from '../contexts/chat-overlay-context';

interface ChatContainerProps {
  children: ReactNode;
  className?: string;
  isVisible?: boolean;
}

/**
 * Container wrapper component that handles the main chat container styling and layout.
 * Uses context to determine fullscreen and sidebar state for conditional styling.
 * When isVisible is false, the container is hidden but remains mounted to preserve state.
 */
export function ChatContainer({ children, className, isVisible = true }: ChatContainerProps) {
  const { isSidebarOpen, isFullscreen } = useChatOverlayContext();

  return (
    <div
      className={cn(
        'fixed right-9 bottom-0 z-[1000]',
        'border-border/50 rounded-t-sm border',
        'bg-background',
        'shadow-floating-bar',
        'flex flex-row',
        {
          'inset-0 rounded-none': isFullscreen,
          'h-[50dvh] min-h-[650px] w-[800px] min-w-[600px]': !isFullscreen,
          'rounded-tl-none': isSidebarOpen,
        },
        className,
      )}
      style={{
        pointerEvents: isVisible ? 'auto' : 'none',
        visibility: isVisible ? 'visible' : 'hidden',
      }}
    >
      {children}
    </div>
  );
}
